import { createContext } from 'react';

export type PermissionsContextValue = {
  permissions: string[];
  isSuperAdmin: boolean;
  isLoading: boolean;
  hasPermission: (perm: string) => boolean;
};

export const PermissionsContext = createContext<PermissionsContextValue | undefined>(
  undefined
);
